var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{attrs:{"label":_vm.label,"type":(_vm.hasError() ? 'is-danger': ''),"message":_vm.errorMessage()}},[_c('b-select',{attrs:{"value":_vm.value,"disabled":_vm.disabled},on:{"input":_vm.inputListener}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }